import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AddPatientPharmacyRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchAddPharmacyToPatientByUserId } from '../api/addPharmacyToPatientByUserId.js';
import { rxKeys } from './keys.js';

export interface AddPatientPharmacyVariables {
  userId: string;
  data: AddPatientPharmacyRequestT;
}

export function useAddPatientPharmacyMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'patient', 'pharmacies', 'add'],
    mutationFn: async ({ userId, data }: AddPatientPharmacyVariables) => {
      return await fetchAddPharmacyToPatientByUserId(userId, data);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({ queryKey: rxKeys.patientPharmacies(variables.userId) });
    },
  });
}
